import {
  Grid,
  Typography,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
  Chip,
} from "@mui/material";
import { useEffect, useState } from "react";
import PageLayout from "../common/PageLayout";
import { useDispatch, useSelector } from "react-redux";
import { BsFiles } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import EntryTable from "../entries/EntryTable";
import { AppReviewRepository } from "../repositories/AppReviewRepository";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Enumerations } from "../../config/Enumerations";
import { Transliteration } from "../common/Transliteration";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/mk";
import { TbFilterOff, TbSearch } from "react-icons/tb";
import { themeConfig } from "../../config/ThemeConfig";
import ReviewTable from "./ReviewTable";
import { notifyShowErrorMessage } from "../../store/AlertSlice";
import { ErrorMessageResolver } from "../common/ErrorMessageResolver";

const filterLabels = {
  trackingNumber: "Идентификатор",
  applicantName: "Подносител",
  dateSubmitted: "Датум на поднесување",
  status: "Статус",
};

export default function AssignedReviews() {
  const location = useLocation();
  const [orderBy, setOrderBy] = useState("id");
  const [orderDirection, setOrderDirection] = useState("DESC");
  const auth = useSelector((state) => state.auth);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [statuses, setStatuses] = useState([]);
  const [searchParams, setSearchParams] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    getAllStatuses();
    getAll(0, 10);
  }, []);

  const getAll = (page, size) => {
    setLoading(true);
    setData();
    AppReviewRepository.getAppReviewsAssignedToCurrentUser(
      page,
      size,
      "active",
      searchParams,
    )
      .then((res) => {
        console.log(res.data);
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        dispatch(notifyShowErrorMessage(ErrorMessageResolver.resolve(err)));
      });
  };

  const handleChangePage = (event, newPage) => {
    getAll(newPage, data?.size);
  };

  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    getAll(0, newSize);
  };

  const handleChange = (name, value) => {
    let tmp = { ...searchParams };
    tmp[name] = value;
    setSearchParams(tmp);
  };

  const getAllStatuses = () => {
    AppReviewRepository.getAllStatuses()
      .then((res) => {
        setStatuses(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setAppliedFilters({ ...searchParams });
      getAll(0, 10);
    } else if (event.key === "Escape") {
      setSearchParams({});
      setAppliedFilters({});
      getAll(0, 10);
    }
  };

  return (
    <PageLayout title="Барања" Icon={BsFiles} prev={location.pathname}>
      <Grid container style={{ padding: "10px 0" }}>
        <Grid
          item
          xs={12}
          style={{ padding: "10px 0", gap: "10px", display: "flex" }}
        >
          <TextField
            size="small"
            placeholder="Идентификатор"
            autoComplete="off"
            inputProps={{ spellCheck: "false" }}
            onChange={(e) => {
              handleChange("trackingNumber", e.target.value.toUpperCase());
            }}
            value={searchParams?.trackingNumber || ""}
            className="login-textfield"
            onKeyDown={handleKeyDown}
          />
          <TextField
            size="small"
            placeholder="Подносител"
            autoComplete="off"
            inputProps={{ spellCheck: "false" }}
            onChange={(e) =>
              handleChange(
                "applicantName",
                Transliteration.toUpperCyrilic(e.target.value),
              )
            }
            value={searchParams?.applicantName || ""}
            className="login-textfield"
            onKeyDown={handleKeyDown}
          />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={["day"]}
              label={"Датум на креирање"}
              value={
                searchParams?.dateCreated
                  ? dayjs(searchParams.dateCreated, "DD/MM/YYYY")
                  : null
              }
              onChange={(newValue) => {
                handleChange(
                  "dateCreated",
                  newValue ? newValue.format("DD/MM/YYYY") : null,
                );
              }}
              inputFormat="DD/MM/YYYY"
              renderInput={(params) => (
                <TextField
                  {...params}
                  helperText={null}
                  size="small"
                  sx={{
                    marginTop: "5px",
                  }}
                  value={
                    params.inputProps.value
                      ? dayjs(params.inputProps.value).format("DD/MM/YYYY")
                      : ""
                  }
                />
              )}
              orientation="landscape"
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={["day"]}
              label={"Датум на одлука"}
              value={
                searchParams?.dateOfDecision
                  ? dayjs(searchParams.dateOfDecision, "DD/MM/YYYY")
                  : null
              }
              onChange={(newValue) => {
                handleChange(
                  "dateOfDecision",
                  newValue ? newValue.format("DD/MM/YYYY") : null,
                );
              }}
              inputFormat="DD/MM/YYYY"
              renderInput={(params) => (
                <TextField
                  {...params}
                  helperText={null}
                  size="small"
                  sx={{
                    marginTop: "5px",
                  }}
                  value={
                    params.inputProps.value
                      ? dayjs(params.inputProps.value).format("DD/MM/YYYY")
                      : ""
                  }
                />
              )}
              orientation="landscape"
            />
          </LocalizationProvider>
          <FormControl
            size="small"
            style={{ marginTop: "5px", width: "300px" }}
          >
            <InputLabel id="demo-simple-select-label">Статус</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={searchParams?.reviewStatus || ""}
              label="Статус"
              onChange={(e) =>
                handleChange(
                  "reviewStatus",
                  e.target.value === "" ? null : e.target.value,
                )
              }
            >
              {statuses.map((status) => (
                <MenuItem key={status} value={status}>
                  {Enumerations.AppReviewStatus[status]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{ padding: "0 10px", height: 38, marginTop: "5px" }}
            onClick={() => {
              setAppliedFilters({ ...searchParams });
              getAll(0, 10);
            }}
            startIcon={<TbSearch />}
          >
            {!loading ? (
              <Typography className="login-button-text">Пребарај</Typography>
            ) : (
              <CircularProgress size={20} id="circular-progress" />
            )}
          </Button>
          <Button
            variant="transparent"
            sx={{
              padding: "0 10px",
              height: 38,
              marginTop: "5px",
              border: "1px solid #d0d0d0",
            }}
            startIcon={<TbFilterOff style={{ color: "#ef233c" }} />}
            onClick={() => {
              setSearchParams({});
              setAppliedFilters({});
              getAll(0, 10);
            }}
          >
            {!loading ? (
              <Typography
                variant="caption"
                sx={{
                  fontSize: "14px",
                  fontFamily: "Inter-Regular",
                  marginLeft: "2px",
                  color: themeConfig.palette.secondary.main,
                }}
              >
                Исчисти
              </Typography>
            ) : (
              <CircularProgress size={20} id="circular-progress" />
            )}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <ReviewTable
            data={data}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            loading={loading}
            showArchivedColumn={true}
          />
        </Grid>
      </Grid>
    </PageLayout>
  );
}
